import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaUser } from "react-icons/fa";
import socket from "../../assets/socket";
import toast from "react-hot-toast";

const base_url = process.env.REACT_APP_API_URL;

const AdminMinesGame = () => {
  const token = localStorage.getItem("admin_token");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [totalUser, setTotalUser] = useState();
  const [totalBet, setTotalBet] = useState();
  const [totalWin, setTotalWin] = useState();
  const [profitLose, setProfitLose] = useState();

  const initialGameState = { start: "", end: "", step: "" };
  const [games, setGames] = useState(
    Array(24)
      .fill()
      .map((_, index) => ({
        id: index + 1,
        ...initialGameState,
      })),
  );

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/get/minesGameSettings`,
          {
            headers: {
              Authorization: token,
            },
          },
        );

        if (response.data.success && response.data.data) {
          const fetchedGames = response.data.data.map((setting) => ({
            id: setting.gameId,
            start: setting.startPercentage.toString(),
            end: setting.endPercentage.toString(),
            step: setting.step.toString(),
          }));
          setGames(fetchedGames);
          setTotalUser(response.data.totalUsers);
          setTotalBet(response.data.totalBet);
          setTotalWin(response.data.totalWin);
          setProfitLose(response.data.profitLose);
        }
      } catch (error) {
        toast.error("Failed to fetch game settings");
      }
    };

    fetchSettings();
  }, []);

  // Update game input and auto-calculate end percentage
  const handleGameInput = (gameId, field, value) => {
    setGames((prevGames) =>
      prevGames.map((game) => {
        if (game.id === gameId) {
          let updatedGame = { ...game, [field]: value };

          const start = parseFloat(updatedGame.start);
          const step = parseFloat(updatedGame.step);

          let box = 25 - gameId; // Adjusted box count based on game ID

          // Only calculate if valid numbers
          if (!isNaN(start) && !isNaN(step)) {
            const increasePerBox = step;
            const totalIncrease = increasePerBox * box;
            updatedGame.end = (start + totalIncrease).toFixed(2);
          }

          return updatedGame;
        }
        return game;
      }),
    );
  };

  const handleGameNumberSubmit = async () => {
    try {
      const isValid = games.every((game) => {
        const start = parseFloat(game.start);
        const end = parseFloat(game.end);
        const step = parseFloat(game.step);

        return (
          !isNaN(start) &&
          !isNaN(end) &&
          !isNaN(step) &&
          start >= 0 &&
          start <= 100 &&
          end >= 0 &&
          end <= 100 &&
          step >= 0
        );
      });

      if (!isValid) {
        toast.error("Please enter valid percentages (0-100) and step values");
        return;
      }

      const payload = games.map((game) => ({
        gameId: game.id,
        startPercentage: parseFloat(game.start),
        endPercentage: parseFloat(game.end),
        step: parseFloat(game.step),
      }));

      const response = await axios.post(
        `${base_url}/api/update/minesGameSettings`,
        { games: payload },
        {
          headers: {
              Authorization: token,
            },
        },
      );

      if (response.data.success) {
        toast.success("Game settings updated successfully");
        socket.emit("minesGameSettingsUpdated", payload);
      } else {
        toast.error("Failed to update game settings");
      }
    } catch (error) {
      toast.error("Error updating game settings: " + error.message);
    }
  };

  return (
    <div className="wrapper">
      <div
        className={`content-wrapper ${isSidebarOpen ? "" : "open-content-wrapper"}`}
      >
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6 m-0">
                <h1>Mines Game</h1>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Cards */}
        <section className="p-4 rounded mx-2 ml-1 mb-2">
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4">
            {/* Total User */}
            <div className="col">
              <div
                className="d-flex align-items-center gap-3 p-2 rounded h-100"
                style={{
                  backgroundColor: "#343A40",
                  boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                }}
              >
                <div
                  className="d-flex flex-column justify-content-center align-items-center p-2 rounded"
                  style={{
                    width: "5rem",
                    height: "5rem",
                    backgroundColor: "#f39c12",
                  }}
                >
                  <div style={{ fontSize: "2.5rem", color: "white" }}>
                    <FaUser />
                  </div>
                </div>
                <div className="d-flex flex-column gap-3 text-start fs-5">
                  <h6 className="m-0 text-white">Total User</h6>
                  <p className="m-0 text-white">{totalUser}</p>
                </div>
              </div>
            </div>
            {/* Total Bet */}
            <div className="col">
              <div
                className="d-flex align-items-center gap-3 p-2 rounded h-100"
                style={{
                  backgroundColor: "#343A40",
                  boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                }}
              >
                <div
                  className="d-flex flex-column justify-content-center align-items-center p-2 rounded"
                  style={{
                    width: "5rem",
                    height: "5rem",
                    backgroundColor: "#e74c3c",
                  }}
                >
                  <div style={{ fontSize: "2.5rem", color: "white" }}>B</div>
                </div>
                <div className="d-flex flex-column gap-3 text-start fs-5">
                  <h6 className="m-0 text-white">Total Bet</h6>
                  <p className="m-0 text-white">{totalBet}</p>
                </div>
              </div>
            </div>
            {/* Total Win */}
            <div className="col">
              <div
                className="d-flex align-items-center gap-3 p-2 rounded h-100"
                style={{
                  backgroundColor: "#343A40",
                  boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                }}
              >
                <div
                  className="d-flex flex-column justify-content-center align-items-center p-2 rounded"
                  style={{
                    width: "5rem",
                    height: "5rem",
                    backgroundColor: "#27ae60",
                  }}
                >
                  <div style={{ fontSize: "2.5rem", color: "white" }}>W</div>
                </div>
                <div className="d-flex flex-column gap-3 text-start fs-5">
                  <h6 className="m-0 text-white">Total Win</h6>
                  <p className="m-0 text-white">{totalWin}</p>
                </div>
              </div>
            </div>
            {/* Total P/L */}
            <div className="col">
              <div
                className="d-flex align-items-center gap-3 p-2 rounded h-100"
                style={{
                  backgroundColor: "#343A40",
                  boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                }}
              >
                <div
                  className="d-flex flex-column justify-content-center align-items-center p-2 rounded"
                  style={{
                    width: "5rem",
                    height: "5rem",
                    backgroundColor: "#007BFF",
                  }}
                >
                  <div style={{ fontSize: "2.5rem", color: "white" }}>P/L</div>
                </div>
                <div className="d-flex flex-column gap-3 text-start fs-5">
                  <h6 className="m-0 text-white">Total P/L</h6>
                  <p className="m-0 text-white">{profitLose}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Adjust Result */}
        <section
          className="mx-4 ml-1 mb-4 shadow-lg rounded"
          style={{ backgroundColor: "#343A40" }}
        >
          <h5
            className="text-white p-3 rounded-top m-0"
            style={{ backgroundColor: "#3F6791" }}
          >
            Adjust Result
          </h5>
          <div
            className="text-white px-3 pt-3 d-flex flex-column gap-3"
            style={{ fontSize: "clamp(0.8rem, 2.5vw, 1rem)" }}
          >
            <p className="mb-0 fs-6">
              Set Your Mines Percentage For Mines Games 1 to 24.
            </p>
            {games.map((game) => (
              <label key={game.id} className="form-label">
                <span className="text-white mb-1 d-block fw-bold fs-5">
                  Mines Game - {game.id}
                </span>
                <div className="row">
                  <div className="col-4">
                    <span className="text-white px-1">Start Percentage</span>
                    <input
                      type="text"
                      placeholder="Enter Start Percentage!"
                      className="w-100 bg-transparent border border-secondary text-white rounded-3 p-2"
                      onInput={(e) =>
                        handleGameInput(game.id, "start", e.target.value)
                      }
                      value={parseFloat(game.start).toFixed(2)}
                    />
                  </div>
                  <div className="col-4">
                    <span className="text-white px-1">Next Step</span>
                    <input
                      type="text"
                      placeholder="Enter Next Step!"
                      className="w-100 bg-transparent border border-secondary text-white rounded-3 p-2"
                      onInput={(e) =>
                        handleGameInput(game.id, "step", e.target.value)
                      }
                      value={parseFloat(game.step).toFixed(2)}
                    />
                  </div>
                  <div className="col-4">
                    <span className="text-white px-1">End Percentage</span>
                    <input
                      type="text"
                      className="w-100 bg-transparent border border-secondary text-white rounded-3 p-2"
                      value={parseFloat(game.end).toFixed(1)}
                      readOnly
                    />
                  </div>
                </div>
              </label>
            ))}
          </div>
          <div
            className="d-flex justify-content-center py-3"
            style={{ backgroundColor: "#2F3439" }}
          >
            <button
              className="border-0 px-4 py-2 text-white rounded"
              style={{ backgroundColor: "#3F6791" }}
              onClick={handleGameNumberSubmit}
            >
              Submit
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AdminMinesGame;
